export default function OnboardingFormReducer(state, action) {
  const {
    type,
    key,
    dateRange,
    month,
    interestedRegions,
    trekType,
    services,
    groupSize,
    duration,
    selectedDateCondition,
  } = action;

  switch (type) {
    case 'INCREMENT': {
      return { ...state, [key]: state[key] + 1 };
    }

    case 'DECREMENT': {
      return { ...state, [key]: state[key] - 1 };
    }

    case 'CHANGE': {
      const key = Object.keys(action)[1];

      return { ...state, [key]: action[key] };
    }

    case 'CHANGE_GROUP_SIZE': {
      return { ...state, groupSize };
    }

    case 'CHANGE_DURATION': {
      return { ...state, duration };
    }

    case 'CHANGE_DATE_CONDITION':
      return { ...state, selectedDateCondition };

    case 'CHANGE_DATE_RANGE':
      return { ...state, dateRange };

    case 'CHANGE_MONTH':
      return { ...state, month };

    case 'CHANGE_INTERESTED_REGION':
      return { ...state, interestedRegions };

    case 'CHANGE_TREK_TYPE':
      return { ...state, trekType };

    case 'CHANGE_SERVICES':
      return { ...state, services };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/screens/OnboardingForm/reducer.js